<p-autoComplete
  [dropdown]="true"
  [showClear]="true"
  [multiple]="multiple"
  [forceSelection]="true"
  [delay]="500"
  [(ngModel)]="selected"
  [suggestions]="suggestions"
  [optionLabel]="getItemLabelProperty()"
  (completeMethod)="onLazyLoad($event)"
  (onClear)="onClear($event)"
  (ngModelChange)="handleChange($event)"
  (blur)="onTouched()"
  [disabled]="disabled"
  [placeholder]="placeholder"
  styleClass="w-full"
  appendTo="body"
>
<ng-template let-item pTemplate="item">
  <div>
    <div class="keyword-key" title="{{item.key}}">{{item.key}}</div>
    <div class="keyword-title" title="{{item.title}}">{{item.title}}</div>
  </div>
</ng-template>
</p-autoComplete>
